<template>
  <div
    :class="className"
    :style="{ height: height, width: width }"
  />
</template>

<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { debounce } from '@/utils/util'
const colors = ['#5470C6', '#91CC75'];
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => { return {} }
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions ({ x, time, options } = {}) {
      console.log(options, 'optionsoptionsoptions111111');
      this.chart.setOption({
        baseOption: {
          timeline: {
            axisType: 'category',
            // realtime: false,
            // loop: false,
            autoPlay: true,
            // currentIndex: 2,
            playInterval: 1000,
            // controlStyle: {
            //     position: 'left'
            // },
            data: time,
            // label: {
            //   formatter: function (s) {
            //     return new Date(s).getFullYear();
            //   }
            // }
          },
          // title: {
          //   subtext: '数据来自国家统计局'
          // },
          tooltip: {},
          // legend: {
          //   left: 'right',
          //   data: ['第一产业', '第二产业', '第三产业', 'GDP', '金融', '房地产'],
          //   selected: {
          //     GDP: false,
          //     金融: false,
          //     房地产: false
          //   }
          // },
          calculable: true,
          grid: {
            top: 80,
            bottom: 100,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value.replace('\n', '');
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0 },
              data: x,
              splitLine: { show: false }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '电位(V)',
              position: 'left',
              alignTicks: true,
              axisLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: colors[0]
                }
              },
              axisLabel: {
                formatter: '{value} '
              }
            },
            {
              type: 'value',
              name: '电压(V)',
              position: 'right',
              alignTicks: true,
              axisLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: colors[1]
                }
              },
              axisLabel: {
                formatter: '{value} '
              }
            }
          ],
          series: [
            { name: '通电电位', type: 'line', yAxisIndex: 0, },
            { name: '断电电位', type: 'line', yAxisIndex: 0, },
            { name: '试片断电电位', type: 'line', yAxisIndex: 1, },
          ]
        },
        options: options
      })
    },
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      console.log('object :>> ', this.chartData);
      this.setOptions(this.chartData)
    }
  }
}
</script>
